var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.7,78.524a10.549,10.549,0,1,1,10.547-10.549A10.56,10.56,0,0,1,164.7,78.524Zm0-19.107a8.558,8.558,0,1,0,8.557,8.558A8.568,8.568,0,0,0,164.7,59.417Z",
    transform: "translate(-146.836 -57.427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.282,79.3a7.825,7.825,0,1,1,7.827-7.825A7.834,7.834,0,0,1,179.282,79.3Zm0-13.66a5.835,5.835,0,1,0,5.837,5.836A5.841,5.841,0,0,0,179.282,65.643Z",
    transform: "translate(-141.18 -55.392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.065,91.346h0a1,1,0,0,1-.994-1,11.715,11.715,0,0,0-16.48-10.708,1,1,0,1,1-.809-1.82A13.709,13.709,0,0,1,193.06,90.352,1,1,0,0,1,192.065,91.346Z",
    transform: "translate(-140.613 -51.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.436,91.991a.994.994,0,0,1-.989-.9,16.024,16.024,0,0,0-31.829-.513.98.98,0,0,1-1.115.857.992.992,0,0,1-.857-1.116,18.013,18.013,0,0,1,35.78.579.994.994,0,0,1-.893,1.087A.813.813,0,0,1,183.436,91.991Z",
    transform: "translate(-148.638 -51.789)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroups);
export default __webpack_public_path__ + "static/media/icon_groups.0f14a530be860d634eb19ea5781bb216.svg";
export { ForwardRef as ReactComponent };